<template>
  <div class="well-card-details" :class="{ 'fda-friendly': isFdaFriendly }" @click.stop="">

    <div class="score-text-container">
      <div>CHLOE</div>
      <div>
        Score
      </div>
    </div>
    <kid-score
        :well="well"
    />

    <pn-score :well="well"/>

    <well-status-controls :well="well" :keep-open="isFdaFriendly" mode="cards"/>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import PnScore from '../score-metrics/PnScore'
import KidScore from '../score-metrics/KidScore'
import WellStatusControls from '../common/WellStatusControls'
import {TREATMENT_PAGE_VIEWS} from '../../../business/const'

export default {
  name: 'WellCardDetails',
  components: {

    PnScore,

    KidScore,

    WellStatusControls
  },
  props: {
    well: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState({
      currentView: state => state.navigation.currentView
    }),
    ...mapGetters({
      isFdaFriendly: 'common/isFdaFriendly',
      isTooEarlyForScores: 'timelapse/isTooEarlyForScores',
      tenant: 'common/getTenant'
    }),
    isWellCardView() {
      return this.currentView === TREATMENT_PAGE_VIEWS.WELL_CARDS
    }
  }
}
</script>

<style lang="scss" scoped>
.score-text-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.well-card-details {
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 8px;
  cursor: default;

  &:not(.fda-friendly) {
    grid-template-rows: repeat(3, 1fr) min-content;
  }

  &.fda-friendly {
    grid-template-rows: min-content;
  }

  .fertilization-status {
    @media screen and #{$new-break4close} {
      display: none;
    }
  }
}
</style>

<style lang="scss">
.well-card-details {
  min-width: 85px;

  .well-rank.card {
    .title {
      font-size: 10.5px;
    }

    .value {
      font-size: 14px;

      .ai-icon {
        height: 14px;
      }
    }

    &.top-rank .crown {
      width: 1.5rem;
    }
  }

  .fert-method-dropdown,
  .well-status-controls {
    height: 1.5rem;
  }
}
</style>
